export default {
  banner: {
    title: "通用登录组件",
    subtitle:
      "登录组件（Guard）是一种可嵌入的登录表单，可根据你的需求进行配置，轻松添加各种社会化登录方式，以便你的用户可以无缝登录，并且在不同平台拥有一致的登录体验。",
  },
  advantageData: {
    0: {
      label: "每年身份认证",
      value: `1<span style="font-size:16px;"> 亿 +</span>`,
    },
    1: {
      label: "即需即用的 SDK",
      value: `<div style="display:flex;justify-content: center;"><div style="">1000</div><div style="font-size:35px;margin-left:10px;"> +</div></div>`,
    },
    2: { label: "可用性和稳定性", value: "99.99%" },
  },
};
